import { z } from "zod"
import { WeekdayFresh } from "../common/WeekdayFresh"

export const BookableServiceSlotsSchema = z.object({
  weekDay: z.nativeEnum(WeekdayFresh),
  slots: z.number(),
})

export const BookableServiceSlotsOverrideSchema = z.object({
  date: z.date(),
  slots: z.number(),
  note: z.string().max(500).nullable().optional(),
})

export type BookableServiceSlots = z.infer<typeof BookableServiceSlotsSchema>
export type BookableServiceSlotsOverride = z.infer<
  typeof BookableServiceSlotsOverrideSchema
>
export type AllBookableServiceSlots = {
  [weekday in WeekdayFresh]: number
}
